"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

exports.__esModule = true;
exports.default = LegendItemSet;

var _coerce = _interopRequireDefault(require("@meltwater/coerce"));

var _legendItem = _interopRequireDefault(require("../legend-item"));

/**
 * A function to validate an array of LegendItems
 * @param {LegendItem[]} legendItemArray An array of legendItems
 *
 * @returns {LegendItem[]} A unique array of legend items
 */
function LegendItemSet(legendItemArray) {
  if (!Array.isArray(legendItemArray)) {
    throw new TypeError("legendItemArray must be an array. Provided value: ".concat(JSON.stringify(legendItemArray)));
  }

  if (legendItemArray.length === 0) {
    throw new Error('legendItemArray must not be empty.');
  }

  var uniqueLabels = {};
  return legendItemArray.map(function (legendItem) {
    if (uniqueLabels[legendItem.label]) {
      throw new Error("Duplicate legendItem provided! Duplicate legend: ".concat(legendItem.label));
    }

    uniqueLabels[legendItem.label] = true;
    return (0, _coerce.default)(legendItem, _legendItem.default, "Every entry in legendItemArray must be a valid LegendItem. Provided value: ".concat(JSON.stringify(legendItem)));
  });
}